import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

import { CompanyProvisionRepository } from '@app/domain/ports/tpv/company-provision.repository';
import {
  CompanyProvisionResult,
  CompanyStandaloneResult,
} from '@app/domain/models/tpv/company.model';
import {
  ProvisionCompanyRequest,
  ProvisionCompanyStandaloneRequest,
} from '@app/data/dtos/tpv/company-provision.dto';

/** Mock de provisión de Company en TPV para pruebas sin backend (tpvUseMocks). */
@Injectable()
export class CompanyProvisionMockDataSource extends CompanyProvisionRepository {
  override provisionCompany(
    idCompany: string,
    _request: ProvisionCompanyRequest,
  ): Observable<CompanyProvisionResult> {
    return of({ idCompany, idUnit: this.uuid(`mock-unit-${idCompany}`), status: 'provisioned' }).pipe(
      delay(500),
    );
  }

  override provisionStandalone(
    _request: ProvisionCompanyStandaloneRequest,
    _idempotencyKey: string,
  ): Observable<CompanyStandaloneResult> {
    return of({
      idCompany: this.uuid('mock-company'),
      externalIdCompany: this.uuid('mock-ext-company'),
      externalIdUnit: this.uuid('mock-ext-unit'),
      idGestor: this.uuid('mock-gestor'),
      status: 'provisioned',
    }).pipe(delay(500));
  }

  /** UUID v4 si hay `crypto`, con fallback determinista para entornos sin él. */
  private uuid(fallback: string): string {
    return typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
      ? crypto.randomUUID()
      : fallback;
  }
}
